<div *ngFor="let type of technologyTypesArray">
  <digires-type-filtering-button
    [type]="type"
    [isActive]="technologyStateMap[type]"
    (changeState)="toggleTechnologyFilter($event)"
  ></digires-type-filtering-button>
</div>
